import React from 'react';
import { useMemo } from 'react';
import { AnalyticsConfig } from './AnalyticsConfig';
import AnalyticsContext, {
  Analytics,
  injectAnalytics,
} from './AnalyticsContext';

export interface AnalyticsProviderProps {
  config: AnalyticsConfig;
  children: React.ReactNode;
}

export const AnalyticsProvider = ({
  config,
  children,
}: AnalyticsProviderProps) => {
  const analytics = useMemo(() => {
    injectAnalytics(config);
    Analytics.trackPageView();
    return Analytics;
  }, []);

  return (
    <AnalyticsContext.Provider value={analytics}>
      {children}
    </AnalyticsContext.Provider>
  );
};
